// extracted by mini-css-extract-plugin
module.exports = {"content":"EditQuestionModalStyles_content__IIOea","modalPaper":"EditQuestionModalStyles_modalPaper__reLTe","secondaryBtn":"EditQuestionModalStyles_secondaryBtn__2ZTC7"};